
import { WDListItem } from './wd-list-item'
import WDForm from '../form/wd-form'
import WDActivity from '../modal/wd-activity';

export default class WDListFormItem extends WDListItem
{
	#form = null;

	constructor(cfg)
	{
		super(cfg);
		this.classList.add('wd-list-form-item');

		//remove the standard click event
		this.off('click');

		this.#form = new WDForm();
		this.content = this.#form;

		return this;
	};

	set model(data) { 
		this.#form.model = data; 
	};
	get model() { 
		return this.#form.model; 
	};
	get form() { return this.#form; };

	get modelCanFetch()
	{
		return (this.model?.getReqURI && this.model.getReqURI().length > 0);
	}

	buildContent()
	{	
		const rowCfg = this.config;

		if (rowCfg?.allowSort) 
		{
			this.icon = 'fa-solid fa-sort';
		}

		if (rowCfg?.allowAdd) 
		{
			const btn = this.addButton({ fasIcon: 'plus' });
			if (rowCfg?.addLabel) btn.label = rowCfg.addLabel;
			btn.on('click', () => this.list.addFormItem(this));
		}

		if (rowCfg?.allowRemove)
		{
			const btn = this.addButton({ fasIcon: 'trash' });
			if (rowCfg?.removeLabel) btn.label = rowCfg.removeLabel;
			btn.on('click', () => this.removeItem());

			//don't allow removal of the last item in the list
			if (this.index == '0' && !rowCfg?.allowRemoveAll) btn.style.visibility = 'hidden';
		}

		if (rowCfg?.buttons)
		{
			rowCfg.buttons.forEach(btnCfg => this.addButton(btnCfg));
		}

		//pointer for later
		const forms = rowCfg?.forms || [];
		const parentList = this.closest('.wd-list');

		forms.forEach( formItem =>
		{
			//clone the formthis.  The variables are stomping on each other
			const formCfg = Object.assign({ wrapper_class: 'col-12' }, formItem);

			const cell = this.add(formCfg);
			const newForm = cell.firstChild;
		
			newForm.on('change', (evt) =>
			{
				if (this.modelCanFetch)
				{
					//run this in a timeout so other events watching for changes can 
					//fire before we autosave.  Allows us to run triggers on the data
					setTimeout(() =>
					{
						this.post().then(results => {
							this.trigger('form:changed',evt);
					 	} );
					}, 250);

				}
				else
				{
					this.trigger('form:changed', evt);
				}
			});

		});

	}


	add(formCfg)
	{
		//just passed a regular element, add that instead
		//create a cell that we can add our form to
		const cell = super.add();

		if (formCfg instanceof HTMLElement) 
		{
			cell.append(formCfg);
			resolve(cell);
		}
		else
		{
			cell.classList.add(formCfg.name);
			cell.append( this.#form.buildForm(formCfg) );

			return cell;
		}

	};

	removeItem()
	{
		//if not set, or set to true - new syntax for me
		if (this.config.deleteConfirm ?? true)
		{
			new WDActivity().showDelete(() => this.runRemove());
		}
		//no confirmation, just do
		else
		{
			this.runRemove();
		}
	};

	runRemove()
	{
		//delete the item if it was saved (how can we tell?)
		if (this.modelCanFetch)
		{
			this.del().then(() =>
			{
				this.list.model.remove(this.index);
				this.trigger('item:removed');
			});
		}
		else
		{
			this.list.model.remove(this.index);
			this.list.trigger('item:removed');
		}

	};

	getItem(key)
	{
		// DOM-based lookup using data-form-name attribute
		return this.querySelector(`[data-form-name="${key}"]`);
	}

	getFormById(id)
	{
		// DOM-based lookup using id
		return this.querySelector(`#${id}`);
	}

	get value() { return this.#form.value; };
	set value(val) { this.#form.value = val; };

	req() { return this.model.req(); };
	post() { return this.model.post(); };
	del() { return this.model.del(); };


	cleanupCallback()
	{
		// Call parent cleanup FIRST
		super.cleanupCallback();

		// Clean up form component
		if (this.#form)
		{
			this.#form = null;
		}
	}

};

customElements.define('wd-list-form-item', WDListFormItem);
